import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, AppService } from './_services';
import { User } from './_models';
import { ModalService } from './_modal';
import { WebcamImage } from 'ngx-webcam';
import { TranslateService} from '@ngx-translate/core';
@Component({ selector: 'app', templateUrl: 'app.component.html',styleUrls: ['./app.component.scss'] })
export class AppComponent {
    @ViewChild('mainMenuToggle') mainMenuToggle: ElementRef<HTMLElement>;
    currentUser: User;
    routerUrl:string='';
    public webcamImage: WebcamImage = null;
    TransLang=[];
    selectLang:string='';
    useFooter:number=0;
    constructor(
        private translate: TranslateService,
        private modalService: ModalService,
        public appService: AppService,
        public router: Router,
        public authenticationService: AuthenticationService,
    ) {
        this.authenticationService.currentUser.subscribe(x =>{
            this.currentUser = x
        });
        translate.setDefaultLang(appService.SiteLang);
        translate.addLangs(['en', 'he']);
        translate.use(appService.SiteLang);
    }
    ngOnInit(){
        this.selectLang='en';
        this.getTransLanguage();
        var _urls: Array<string> = ['/', '/terms', '/aboutus', 'contactus'];
        this.appService.siteLangSubject.subscribe((val) => {
            this.translate.use(val);
        });
        // if (_urls.includes(this.router.url)) {
        //     this.useFooter=0;
        //     }
    }

    setTransLanguage(){
        this.appService.changeSiteLang(this.selectLang);
        this.translate.use(this.appService.SiteLang);
    }
    getTransLanguage(){
        this.TransLang=this.translate.getLangs();
        }
    closeMenu() {
        //console.log('CloseMenu Clicked');
        let el: HTMLElement = this.mainMenuToggle.nativeElement;
        console.log(el);
        el.click();
    }
    

    logout() {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
    }

    onModalClosed(id:string){
        // console.log("onModalClosed called");
        // alert(id);
    }
    showLogin(){
        this.modalService.open("login");
    }
    showSignUp(){
        this.modalService.open("signup");
    }
    handleImage(webcamImage: WebcamImage): void {
        console.info('received webcam image', webcamImage);
        this.webcamImage = webcamImage;
       }
}